import event from '@/event-bus/event';
import validateAlert from '@/components/service/alert/validate-alert.vue';
import addRoamItemAlert from '@/components/service/alert/addRoamItem-alert.vue';
import switchDataRoamingAlert from '@/components/service/alert/switchDataRoaming-alert.vue';
import countryRoamingAlert from '@/components/service/alert/countryRoamConfirm-alert.vue';

export default {
  name: 'gt-alert',
  mixins: [],
  extends: {},
  components: { validateAlert, addRoamItemAlert, switchDataRoamingAlert, countryRoamingAlert },
  props: [],
  data() {
    return {
      width: '600px',
      isShow: false,
      // 0為空 1為message alert 2.為權限選擇器
      alertType: 0,
      alertMsg: '',
      roamItem:{
        roamingOperator: '',
        pickupStart: '',
        pickupEnd: '',
        dataBasicStatus: { serviceList: [] },
        showWarnMsg: false,
      },
      dataRoamFlagSwitch:{
        showReservationWarn: false,
        dataRoamFlag: '',
      },
      countryRoamItem:{
        serviceID: '',
        applyStatusARW: '',
        applyStatusCDW: '',
      },
      cbFun: null
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$bus.$on(event.validateAlert, (msg) => {
      this.alertMsg = msg;
      this.alertType = 1;
      this.isShow = true;
    }),
    this.$bus.$on(event.addRoamItemAlert, (param) => {
      this.roamItem.roamingOperator = param.roamingOperator
      this.roamItem.pickupStart = param.pickupStart
      this.roamItem.pickupEnd = param.pickupEnd
      this.roamItem.showWarnMsg = param.showWarnMsg
      this.alertType = 2;
      this.isShow = true;
    });
    this.$bus.$on(event.switchDataRoamingAlert, (param) => {
      this.alertType = 3;
      this.isShow = param.isShow;
      this.dataRoamFlagSwitch.showReservationWarn = param.showReservationWarn
      this.dataRoamFlagSwitch.dataRoamFlag = param.dataRoamFlag;
    });
    this.$bus.$on(event.countryRoamingAlert, (countryRoamItem, roamItem, switchDataRoamingAlert, cbFun) => {
      this.width = "1200px";
      this.isShow = true;
      this.alertType = 4;
      this.$data.countryRoamItem = this.$options.data().countryRoamItem;
      this.$data.roamItem = this.$options.data().roamItem;
      // 購買語音漫遊
      if (countryRoamItem) {
        this.countryRoamItem.serviceID = countryRoamItem.serviceID;
        this.countryRoamItem.applyStatusARW = countryRoamItem.applyStatusARW;
        this.countryRoamItem.applyStatusCDW = countryRoamItem.applyStatusCDW;
      }
      // 購買國際漫遊
      if(cbFun) {
        this.cbFun = cbFun;
      }
      // // 購買日租
      // if (roamItem) {
      //   this.roamItem.roamingOperator = roamItem.roamingOperator
      //   this.roamItem.pickupStart = roamItem.pickupStart
      //   this.roamItem.pickupEnd = roamItem.pickupEnd
      //   this.roamItem.showWarnMsg = roamItem.showWarnMsg
      // }
      // // 購買非日租
      // if (switchDataRoamingAlert) {
      //   this.dataRoamFlagSwitch.showReservationWarn = switchDataRoamingAlert.showReservationWarn
      //   this.dataRoamFlagSwitch.dataRoamFlag = switchDataRoamingAlert.dataRoamFlag;
      // }
      
    });
  },
  mounted() {
    $("[data-fancybox]").fancybox({
      smallBtn: true,
      toolbar: false
    });
    $("[data-fancybox].iframeS").fancybox({
      smallBtn: true,
      toolbar: false,
      afterLoad: function(event, ui) {
        $('.fancybox-content').addClass('small')
      }
    });
  },
  updated() {},
  beforeDestroy() {
  },
  methods: {
    closeBox() {
      this.init();
      this.isShow = false;
    },
    init() {
      this.alertType = 0;
      this.alertMsg = '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/service/alert/gt-alert.js